import { STATES } from '@interfaces/realEstates/enums/states'

export const states = [
    { value: STATES.AC, title: 'Acre' },
    { value: STATES.AL, title: 'Alagoas' },
    { value: STATES.AP, title: 'Amapá' },
    { value: STATES.AM, title: 'Amazonas' },
    { value: STATES.BA, title: 'Bahia' },
    { value: STATES.CE, title: 'Ceará' },
    { value: STATES.DF, title: 'Distrito Federal' },
    { value: STATES.ES, title: 'Espirito Santo' },
    { value: STATES.GO, title: 'Goiás' },
    { value: STATES.MA, title: 'Maranhão' },
    { value: STATES.MS, title: 'Mato Grosso do Sul' },
    { value: STATES.MT, title: 'Mato Grosso' },
    { value: STATES.MG, title: 'Minas Gerais' },
    { value: STATES.PA, title: 'Pará' },
    { value: STATES.PB, title: 'Paraíba' },
    { value: STATES.PR, title: 'Paraná' },
    { value: STATES.PE, title: 'Pernambuco' },
    { value: STATES.PI, title: 'Piauí' },
    { value: STATES.RJ, title: 'Rio de Janeiro' },
    { value: STATES.RN, title: 'Rio Grande do Norte' },
    { value: STATES.RS, title: 'Rio Grande do Sul' },
    { value: STATES.RO, title: 'Rondônia' },
    { value: STATES.RR, title: 'Roraima' },
    { value: STATES.SC, title: 'Santa Catarina' },
    { value: STATES.SP, title: 'São Paulo' },
    { value: STATES.SE, title: 'Sergipe' },
    { value: STATES.TO, title: 'Tocantins' },
]
